import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ACol from "antd/lib/col";
import { basicStyle } from "./basicStyle";
// HoC 를 사용하여 기본 스타일을 적용한다.
// High order Component
// curry function
// https://levelup.gitconnected.com/devmade-curry-ing-powder-recipe-in-functional-programming-c6e0e45cfbae
// 데코레이터 패턴
// https://refactoring.guru/ko/design-patterns/decorator
// const withDefaultPropsCol = (Component) => {
// 	const defaultProps = {
// 		...basicStyle,
// 	}
//
// 	return (props: ColProps) => <Component {...defaultProps} {...props} />
// }
//
// const ColWithHoc = withDefaultPropsCol(Col)
// const Col = withDefaultPropsCol(Col)
const Col = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ _jsx(ACol, {
        ...props,
        style: (props === null || props === void 0 ? void 0 : props.style) || basicStyle.colStyle,
        children: children
    });
};
export { Col };
